<script setup lang="ts">
import ListEventRow from './ListEventRow.vue'
import type { WebinarCalendarEvent, WebinarPageContext } from '../types'

defineProps<{
  currentDate: Date
  events: WebinarCalendarEvent[]
  pageContext?: WebinarPageContext
}>()

const emit = defineEmits<{
  (e: 'event-open', id: number): void
  (e: 'event-like', id: number): void
  (e: 'event-purchase', id: number): void
  (e: 'video-purchase', id: number): void
}>()
</script>

<template>
  <div class="webinar-calendar__view webinar-calendar__view_list">
    <div v-if="!events.length" class="webinar-calendar__list-placeholder">
      <span class="text-title-bold">Нет вебинаров.</span>
      <span> По заданным фильтрам ничего не нашлось. </span>
    </div>

    <table v-else width="100%">
      <ListEventRow
        v-for="event in events"
        :key="event.id"
        :event="event"
        :current-date="currentDate"
        :page-context="pageContext"
        @action="
          ({ type, id }) => {
            if (type === 'event-open') emit('event-open', id)
            if (type === 'event-like') emit('event-like', id)
            if (type === 'event-purchase') emit('event-purchase', id)
            if (type === 'video-purchase') emit('video-purchase', id)
          }
        "
      />
    </table>
  </div>
</template>

<style lang="scss">
.webinar-calendar {
  &__view_list {
    & table,
    & td {
      border: 1px $lightGray solid;
      border-collapse: collapse;
    }
  }

  &__list-placeholder {
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: $darkGray;
  }
}
</style>
